/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './user-change-password-form.component';
export * from './user-change-password-form.module';
export * from './user-change-password-form.service';
